import React from 'react';
import moment from 'moment';
import { getSessionCookie } from '../../helpers/cookies';

/**
 * Rodapé fixo para documentos impressos/exportados em PDF.
 * Aparece no rodapé de TODAS as páginas impressas usando position:fixed + @media print.
 * Exibe: "Documento extraído do sistema FLIC, no dia DD/MM/YYYY, hora HH:MM, usuário XXXXXXXXXX"
 */
export default function PrintFooter() {
    const session = getSessionCookie();
    const now = moment();
    const dia = now.format('DD/MM/YYYY');
    const hora = now.format('HH:mm');
    const usuario = session?.nome || session?.login || '-';
    const texto = `Documento extraído do sistema FLIC, no dia ${dia}, hora ${hora}, usuário ${usuario}.`;

    return (
        <>
            {/* Espaçador: reserva a altura do rodapé no final do conteúdo */}
            <div className="print-footer-spacer" />

            {/* Rodapé fixo: só aparece na impressão */}
            <div className="print-footer">
                {texto}
            </div>

            <style>{`
                @media print {
                    .print-footer {
                        position: fixed;
                        bottom: 0;
                        left: 0;
                        right: 0;
                        border-top: 1px solid #ccc;
                        padding: 6px 16px;
                        font-size: 16px;
                        color: #555;
                        text-align: center;
                        font-style: italic;
                        background: #fff;
                        z-index: 9999;
                    }

                    .print-footer-spacer {
                        height: 32px;
                    }
                }

                @media screen {
                    .print-footer {
                        display: none;
                    }
                    .print-footer-spacer {
                        display: none;
                    }
                }
            `}</style>
        </>
    );
}
